import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
var InfoDisplay = /** @class */ (function (_super) {
    tslib_1.__extends(InfoDisplay, _super);
    function InfoDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeImage = null;
        return _this;
    }
    InfoDisplay.prototype.created = function () {
        if (this.content.images)
            this.activeImage = this.content.images[0];
    };
    InfoDisplay.prototype.move = function (direction) {
        var index = this.content.images.indexOf(this.activeImage) + direction;
        if (index < 0)
            index = this.content.images.length - 1;
        if (index >= this.content.images.length)
            index = 0;
        this.activeImage = this.content.images[index];
    };
    InfoDisplay.prototype.isActive = function (image) {
        return this.activeImage == image;
    };
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], InfoDisplay.prototype, "content", void 0);
    InfoDisplay = tslib_1.__decorate([
        Component
    ], InfoDisplay);
    return InfoDisplay;
}(Vue));
export default InfoDisplay;
